<ng-container *ngIf="{
    row: columnData | async
  } as $">
  <p >{{$.row!.class_utilization}} % </p>
  </ng-container>